import React, { useEffect, useState } from "react";
import { Amplify, API, graphqlOperation } from "aws-amplify";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import "../../styles/car-item.css";
import { listProductCategories } from "../../graphql/queries";

const listProductCategoryLinks = [{}];

const ProductItem = (props) => {
  const { image, navigateTo, title } = props.item;

  return (
    <Col lg="4" md="4" sm="6" className="mb-3">
      <Link to={`/product-category/${navigateTo}`}>
        <div className="car__item">
          <div className="car__img">
            <img
              src={image}
              height="250px"
              // width="150px"
              alt=""
              className="w-100"
            />
          </div>
          <div className="car__item-content mt-3">
            <h4 className="section__title text-center">{title}</h4>
          </div>
        </div>
      </Link>
    </Col>
  );
};

export default ProductItem;
